import { Grid, Divider, Stack, TextField } from '@mui/material';
import { textFieldProps } from '../constants/form';
import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';
import { Account } from '../../../state/accountModalSlice';
import { getFormikField } from '../../../util/fornik-helpers';

export default function About({
  formik,
}: {
  formik: FormikProps<Account>;
}): JSX.Element {
  const { t: tGC } = useTranslation([], { keyPrefix: 'team.Global.Common' });

  return (
    <>
      <Divider sx={{ marginBottom: 1 }} />
      <Stack
        gap={2}
        direction={'row'}
        justifyContent={'space-around'}
        width={'100%'}
        sx={{ marginY: 2 }}
      >
        <Stack gap={2} width={'100%'}>
          <Grid>
            <TextField
              variant="filled"
              disabled
              {...textFieldProps}
              label={tGC('Email')}
              name="email"
              type="text"
              error={Boolean(getFormikField(formik, 'email').error)}
              helperText={getFormikField(formik, 'email').error}
              value={getFormikField(formik, 'email').value}
              onChange={formik.handleChange}
            />
          </Grid>
          <Grid>
            <TextField
              variant="filled"
              {...textFieldProps}
              label={tGC('First Name')}
              name="firstName"
              type="text"
              error={Boolean(getFormikField(formik, 'firstName').error)}
              helperText={getFormikField(formik, 'firstName').error}
              value={getFormikField(formik, 'firstName').value}
              onChange={formik.handleChange}
            />
          </Grid>
          <Grid>
            <TextField
              variant="filled"
              {...textFieldProps}
              label={tGC('Last Name')}
              name="lastName"
              type="text"
              error={Boolean(getFormikField(formik, 'lastName').error)}
              helperText={getFormikField(formik, 'lastName').error}
              value={getFormikField(formik, 'lastName').value}
              onChange={formik.handleChange}
            />
          </Grid>
        </Stack>
      </Stack>
    </>
  );
}
